<template>
  <div>
    <v-layout
      class="mt-4"
      wrap
      column
      reverse
    >
      <v-flex
        v-for="(item, index) in filteredChangesList"
        :key="index"
        xs12
        :class="[$vuetify.breakpoint.smAndDown ? 'mb-3' : 'mb-2']"
      >
        <v-layout :wrap="$vuetify.breakpoint.smAndDown">
          <v-flex
            xs6
            auto
          >
            <p class="mb-0">
              {{ formatDate(item?.created_at, { format: DATE_FORMATS['DAYS.MONTHS.YEARS_HOURS:MINUTES:SECONDS']}) }}
            </p>
          </v-flex>
          <v-flex
            xs6
            auto
          >
            <p class="mb-0">
              {{ user(item) }}
            </p>
          </v-flex>
          <v-flex
            xs12
            auto
          >
            <p
              class="mb-0"
              v-html="item.action.description"
            />
          </v-flex>
        </v-layout>
        <v-divider />
      </v-flex>
    </v-layout>
    <div class="text-xs-center">
      <a
        v-if="visibleChangesList.length > 4"
        @click="expandList"
      >{{ expandText }}</a>
    </div>
  </div>
</template>

<script>
import { formatDate, DATE_FORMATS } from '@/utils/formatDate';

export default {
    name: 'FamilyChangeLog',
    props: {
        changesList: {
            type: Array,
            required: true,
            default: () => {
                return [];
            }
        }
    },
    data () {
        return {
            DATE_FORMATS,
            listLimit: 4,
            limited: true
        };
    },
    computed: {
        filteredChangesList () {
            if (this.limited === true && this.visibleChangesList.length >= this.listLimit) {
                return this.visibleChangesList.slice(
                    this.visibleChangesList.length - this.listLimit,
                    this.visibleChangesList.length
                );
            } else {
                return this.visibleChangesList;
            }
        },
        visibleChangesList () {
            return this.changesList.filter((item) => {
                return item.visible === 1;
            });
        },
        expandText () {
            return this.limited
                ? this.$t('family_card.changelog.show_more')
                : this.$t('family_card.changelog.show_less');
        }
    },
    methods: {
        formatDate,
        user (item) {
            const firstName = item.user_first_name ? item.user_first_name : '';
            const lastName = item.user_last_name ? item.user_last_name : '';
            return `${firstName} ${lastName}`;
        },
        expandList () {
            this.limited = !this.limited;
        }
    }
};
</script>

<style scoped></style>
